// Aggiornato da scripts/aggiorna-versione.sh durante la pubblicazione (publish-*.sh): non modificare a mano
export const VERSIONE_BUILD = '2026.9.25.1';
